import produce from 'immer';
import * as CONSTANTS from './constants';
import * as PRODUCER_JOB_CONSTANTS from '../producerJob/constants';

/**
 @CAUTION need to separate the loading state unless it might cause infinite loop
 */

export const initialState = {
  jobs: [],
  archivedMemos: [],
  declinedMemos: [],
  job: null,
  freelancerJobCounter: 0,
  list: {
    loading: true,
    error: null
  },
  detail: {
    loading: true,
    error: null
  },
  archiveMemo: {
    loading: false,
    error: null,
    id: null
  },
  delete: {
    loading: false,
    error: null
  },
  deleteBulk: {
    //not removing may required in archived jobs currently not used
    loading: false,
    error: null
  },
  acceptOrDecline: {
    loading: false,
    error: null,
    companyEmail: null
  }
};

const contractorJobReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.FETCH_JOB_COUNTER_SUCCESS:
        draft.freelancerJobCounter = action.data.new_jobs_amount;
        break;

      case CONSTANTS.ACCEPT_OR_DECLINE_JOB_REQUEST:
        draft.acceptOrDecline = {
          loading: true,
          error: null,
          companyEmail: null
        };
        break;
      case CONSTANTS.ACCEPT_OR_DECLINE_JOB_SUCCESS:
        draft.acceptOrDecline = {
          loading: false,
          error: null,
          companyEmail: action.data
        };
        break;
      case CONSTANTS.ACCEPT_OR_DECLINE_JOB_RESET:
        draft.acceptOrDecline = {
          loading: false,
          error: null,
          companyEmail: null
        };
      // case CONSTANTS.ACCEPT_OR_DECLINE_JOB_FAIL:
      //   draft.acceptOrDecline = {loading: false, error: action.error};
      //   break;

      // case CONSTANTS.CANCEL_JOB_REQUEST:
      //   draft.canceljob = { loading: true, error: null };
      //   break;
      case CONSTANTS.CANCEL_JOB_SUCCESS:
        draft.job = { ...draft.job, canceled: true };
        // draft.canceljob = { loading: false, error: null };
        break;
      // case CONSTANTS.CANCEL_JOB_FAIL:
      //   draft.canceljob = { loading: false, error: action.error };
      //   break;

      case CONSTANTS.FETCH_CONTRACTOR_JOBS_REQUEST:
        draft.list = { loading: true, error: null };
        break;
      case CONSTANTS.FETCH_CONTRACTOR_JOBS_SUCCESS:
        draft.jobs = action.data;
        draft.list = { loading: false, error: null };
        break;
      case CONSTANTS.FETCH_CONTRACTOR_JOBS_FAIL:
        draft.list = { loading: false, error: action.error };
        break;

      case CONSTANTS.FETCH_CONTRACTOR_JOB_DETAIL_REQUEST:
        draft.detail = { loading: true, error: null };
        break;
      case CONSTANTS.FETCH_CONTRACTOR_JOB_DETAIL_SUCCESS:
        draft.job = action.data;
        draft.detail = { loading: false, error: null };
        break;
      case CONSTANTS.FETCH_CONTRACTOR_JOB_DETAIL_FAIL:
        draft.detail = { loading: false, error: action.error };
        break;

      // case CONSTANTS.UPDATE_CONTRACTOR_JOB_REQUEST:
      //   draft.update = {loading: true, error: null};
      //   break;
      case CONSTANTS.UPDATE_CONTRACTOR_JOB_SUCCESS:
        draft.job = action.data;
        draft.jobs = draft.jobs.map((job) =>
          job.id === action.data.id ? action.data : job
        );
        // draft.update = {loading: false, error: null};
        break;
      // case CONSTANTS.UPDATE_CONTRACTOR_JOB_FAIL:
      //   draft.update = {loading: false, error: action.error};
      //   break;

      case CONSTANTS.DELETE_BULK_CONTRACTOR_JOB_REQUEST:
        draft.deleteBulk = { loading: true, error: null };
        break;
      case CONSTANTS.DELETE_BULK_CONTRACTOR_JOB_SUCCESS:
        draft.jobs = draft.jobs.filter(({ id }) => !action.data.includes(id));
        draft.deleteBulk = { loading: false, error: null };
        break;
      case CONSTANTS.DELETE_BULK_CONTRACTOR_JOB_FAIL:
        draft.deleteBulk = { loading: false, error: action.error };
        break;
      case CONSTANTS.ARCHIVE_MEMO_REQUEST:
        draft.archiveMemo = { loading: true, error: null, id: action.memoId };
        break;
      case CONSTANTS.ARCHIVE_MEMO_SUCCESS:
        draft.archiveMemo = {
          ...draft.archiveMemo,
          ...{
            loading: false,
            error: null
          }
        };
        draft.job = action.data;
        draft.jobs = draft.jobs.filter((job) => job.id != action.data.id);
        break;
      case CONSTANTS.ARCHIVE_MEMO_FAIL:
        draft.archiveMemo = {
          ...draft.archiveMemo,
          ...{
            loading: false,
            error: action.error
          }
        };
        break;

      case CONSTANTS.FETCH_ARCHIVED_MEMO_REQUEST:
        draft.list = { loading: true, error: null };
        break;
      case CONSTANTS.FETCH_ARCHIVED_MEMO_SUCCESS:
        draft.archivedMemos = action.payload;
        draft.list = { loading: false, error: null };
        break;
      case CONSTANTS.FETCH_ARCHIVED_MEMO_FAIL:
        draft.list = { loading: false, error: action.error };
        break;
      case CONSTANTS.DELETE_BULK_ARCHIVED_MEMO_REQUEST:
        draft.deleteBulk = { loading: true, error: null };
        break;
      case CONSTANTS.DELETE_BULK_ARCHIVED_MEMO_SUCCESS:
        draft.archivedMemos = draft.archivedMemos.filter(
          ({ id }) => !action.data.includes(id)
        );
        draft.deleteBulk = { loading: false, error: null };
        break;
      case CONSTANTS.DELETE_BULK_ARCHIVED_MEMO_FAIL:
        draft.deleteBulk = { loading: false, error: action.error };
        break;

      case CONSTANTS.FETCH_DECLINED_MEMO_REQUEST:
        draft.list = { loading: true, error: null };
        break;
      case CONSTANTS.FETCH_DECLINED_MEMO_SUCCESS:
        draft.declinedMemos = action.payload;
        draft.list = { loading: false, error: null };
        break;
      case CONSTANTS.FETCH_DECLINED_MEMO_FAIL:
        draft.list = { loading: false, error: action.error };
        break;
      case CONSTANTS.DELETE_BULK_DECLINED_MEMO_REQUEST:
        draft.deleteBulk = { loading: true, error: null };
        break;
      case CONSTANTS.DELETE_BULK_DECLINED_MEMO_SUCCESS:
        draft.declinedMemos = draft.declinedMemos.filter(
          ({ id }) => !action.data.includes(id)
        );
        draft.deleteBulk = { loading: false, error: null };
        break;
      case CONSTANTS.DELETE_BULK_DECLINED_MEMO_FAIL:
        draft.deleteBulk = { loading: false, error: action.error };
        break;

      case CONSTANTS.DELETE_SINGLE_JOB_MEMO_REQUEST:
        draft.delete = { loading: true, error: null };
        break;
      case CONSTANTS.DELETE_SINGLE_JOB_MEMO_SUCCESS:
        draft.archivedMemos = draft.archivedMemos.filter(
          ({ id }) => id !== action.payload.jobMemoId
        );
        draft.delete = { loading: false, error: null };
        break;
      case CONSTANTS.DELETE_SINGLE_JOB_MEMO_FAIL:
        draft.delete = { loading: false, error: action.error };
        break;
      case PRODUCER_JOB_CONSTANTS.VIEWED_COMMENT_SUCCESS:
      case PRODUCER_JOB_CONSTANTS.ADD_COMMENT_SUCCESS:
        draft.job = {
          ...draft.job,
          comments: action.data.comments
        };
        break;

      default:
        break;
    }
  });

export default contractorJobReducer;
